export default "\n<app-development-panel *ngIf=\"!environment.production\"></app-development-panel>\n<router-outlet></router-outlet>"